// extracted by mini-css-extract-plugin
export var button = "bZ_qp";
export var button__darkBlue = "bZ_qt";
export var button__edgesGrey = "bZ_qv";
export var button__edgesRed = "bZ_qr";
export var button__loader = "bZ_qw";
export var button__red = "bZ_qq";
export var button__transparent = "bZ_qs";
export var loadingSpinner = "bZ_qx";